(function () {
  const API_URL = "https://appbundle.bariatricpal.com/Recall/Submit"; 

  const form = document.getElementById("recall-form");
  const submitBtn = document.getElementById("recall-submit");
  const msgBox = document.getElementById("recall-message");

  const fields = {
    firstName: document.getElementById("recall-first-name"),
    lastName: document.getElementById("recall-last-name"),
    email: document.getElementById("recall-email"),
    product: document.getElementById("recall-product"),
    lot: document.getElementById("recall-lot"),
    capYes: document.getElementById("recall-cap-yes"),
    capNo: document.getElementById("recall-cap-no"),
    bottleCount: document.getElementById("recall-bottle-count"),
    address1: document.getElementById("recall-address1"),
    city: document.getElementById("recall-city"),
    state: document.getElementById("recall-state"),
    zip: document.getElementById("recall-zip"),
  };

  const errors = {
    firstName: document.getElementById("err-first-name"),
    lastName: document.getElementById("err-last-name"),
    email: document.getElementById("err-email"),
    product: document.getElementById("err-product"),
    lot: document.getElementById("err-lot"),
    cap: document.getElementById("err-cap"),
    bottleCount: document.getElementById("err-bottle-count"),
    address1: document.getElementById("err-address1"),
    csz: document.getElementById("err-csz"),
  };

  function showMessage(text, type) {
    msgBox.className = "recall-row recall-alert " + (type === "success" ? "recall-alert--success" : "recall-alert--error");
    msgBox.textContent = text;
    msgBox.style.display = "block";
  }

  function clearMessages() {
    msgBox.style.display = "none";
    Object.values(errors).forEach(el => el && (el.textContent = ""));
  }

  function validateEmail(value) {
    // Simple pattern: [some_chars]@[some_chars].[some_chars]
    // Disallows spaces and multiple @ signs.
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

  function validate() {
    clearMessages();
    let ok = true;

    if (!fields.firstName.value.trim()) { errors.firstName.textContent = "First name is required."; ok = false; }
    if (!fields.lastName.value.trim()) { errors.lastName.textContent = "Last name is required."; ok = false; }

    if (!fields.email.value.trim()) {
      errors.email.textContent = "Email is required."; ok = false;
    } else if (!validateEmail(fields.email.value.trim())) {
      errors.email.textContent = "Enter a valid email."; ok = false;
    }

    if (!fields.product.value) { errors.product.textContent = "Please select a product."; ok = false; }
    if (!fields.lot.value.trim()) { errors.lot.textContent = "Lot number is required."; ok = false; }

    const capChecked = fields.capYes.checked || fields.capNo.checked;
    if (!capChecked) { errors.cap.textContent = "Please select Yes or No."; ok = false; }

    if (!fields.bottleCount.value || Number(fields.bottleCount.value) < 1) {
      errors.bottleCount.textContent = "Enter number of bottles (min 1)."; ok = false;
    }

    if (!fields.address1.value.trim()) { errors.address1.textContent = "Street address is required."; ok = false; }

    let cszOk = true;
    if (!fields.city.value.trim()) cszOk = false;
    if (!fields.state.value.trim()) cszOk = false;
    if (!fields.zip.value.trim()) cszOk = false;

    if (!cszOk) { errors.csz.textContent = "City, State, and Zip are required."; ok = false; }

    return ok;
  }

  function serialize() {
    return {
      first_name: fields.firstName.value.trim(),
      last_name: fields.lastName.value.trim(),
      email: fields.email.value.trim(),
      product: fields.product.value,
      lot_numbers: fields.lot.value.trim(),
      cap_has_child_resistant: fields.capYes.checked ? true : false,
      bottle_count: Number(fields.bottleCount.value),
      address1: fields.address1.value.trim(),
      city: fields.city.value.trim(),
      state: fields.state.value.trim(),
      zip: fields.zip.value.trim(),
      // Optional: include fixed recall metadata if useful server-side
      brand: "BariatricPal",
      single_product_name: "BariatricPal Ultra Multi Bariatric Multivitamin"
    };
  }

  // Optional: Anti-forgery token support (ASP.NET MVC)
  function getCsrfHeader() {
    // If your layout renders an anti-forgery token like:
    // <input name="__RequestVerificationToken" type="hidden" value="..." />
    // or a meta tag: <meta name="RequestVerificationToken" content="...">
    const meta = document.querySelector('meta[name="RequestVerificationToken"]');
    if (meta && meta.content) {
      return { "RequestVerificationToken": meta.content };
    }
    const tokenInput = document.querySelector('input[name="__RequestVerificationToken"]');
    if (tokenInput && tokenInput.value) {
      return { "RequestVerificationToken": tokenInput.value };
    }
    return {};
  }

  form.addEventListener("submit", async function (e) {
    e.preventDefault();
    if (!validate()) return;

    const payload = serialize();

    submitBtn.disabled = true;
    submitBtn.textContent = "Submitting...";

    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...getCsrfHeader()
        },
        body: JSON.stringify(payload),
        credentials: "omit" // <— no cookies
      });
        
                // Try to parse JSON; fall back to text
        const contentType = res.headers.get("content-type") || "";
        let data = null;
        if (contentType.includes("application/json")) {
            try { data = await res.json(); } catch { /* ignore */ }
        } else {
            try { data = await res.text(); } catch { /* ignore */ }
        }

        // If HTTP error -> show server text/json
        if (!res.ok) {
            const msg = data && typeof data === "object" && data.error
            ? data.error
            : (typeof data === "string" && data) || `Request failed with status ${res.status}`;
            throw new Error(msg);
        }

        // HTTP OK, but API says ok:false
        if (data && typeof data === "object" && data.ok === false) {
            throw new Error(data.error || "Submission failed.");
        }

        showMessage("Thank you! Your request has been submitted successfully.", "success");
        // form.reset();
        } catch (err) {
        showMessage("Submission failed. " + (err.message || "Please try again."), "error");
        } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = "SUBMIT FORM";
        }
  });
})();